"use strict";

exports.__esModule = true;
exports.AlertTagsInput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _TranslatorContext = require("../../Core/Translator/TranslatorContext");
var _styles = require("../styles");
var _vimanaTypes = require("@vimana/vimana-types");
var _AlertValidators = require("../utils/AlertValidators");
var _CommonValidators = require("../utils/CommonValidators");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var getTextValue = function getTextValue(node) {
  return typeof node === "string" ? node : node.textContent;
};
var AlertTagsInput = exports.AlertTagsInput = function AlertTagsInput(props) {
  var _alert$tags;
  var _useContext = (0, _react.useContext)(_TranslatorContext.TranslatorContext),
    translate = _useContext.translate;
  var setAlertTags = props.setAlertTags,
    alert = props.alert,
    disabled = props.disabled;
  return /*#__PURE__*/_react["default"].createElement(_styles.FlexRow, {
    style: {
      width: "100%",
      marginTop: "5px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_styles.InputText, null, translate("AlertDefinition.Panel.Tags", "Alert tags")), /*#__PURE__*/_react["default"].createElement(_styles.Input, {
    style: {
      minWidth: "200px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.TagInput, _extends({
    addOnBlur: true,
    id: "alert-alertTags-value",
    inputProps: {
      "data-testid": "AlertDefinition.AlertDefinitionPanel.AlertTagsValue.input"
    },
    values: (_alert$tags = alert == null ? void 0 : alert.tags) != null ? _alert$tags : []
  }, !(0, _AlertValidators.validateAlertTags)(alert.tags) && {
    intent: _core.Intent.DANGER
  }, {
    tagProps: function tagProps(node) {
      return Object.assign({}, !(0, _CommonValidators.validateAlertName)(getTextValue(node)) && {
        intent: _core.Intent.DANGER
      }, {
        "data-testid": "AlertDefinition.AlertDefinitionPanel.AlertTagsValue.alertName-" + getTextValue(node)
      });
    },
    large: false,
    fill: true,
    onChange: function onChange(values) {
      var tags = values.map(function (value) {
        return getTextValue(value);
      });
      setAlertTags(tags);
    },
    disabled: disabled
  }))));
};